import type { BadgeType } from '@designSystem/components/basic/badge'

export const Statut = [
  'EnCoursAnalyse',
  'AttentePiecesInstruction',
  'RelanceAvantCloture',
  'Cloture',
  'Accorde',
  'Annule',
  'Refuse',
  'Rupture',
  'Transmis',
  'AttentePiecesReglement',
  'TransfereAOpcoMobilite',
  'TransfereAOpco2I',
  'TransfereAOpcommerce',
  'TransfereAOpcoAtlas',
] as const

export type Statut = (typeof Statut)[number]

export type StatutOutilFpe = Extract<
  Statut,
  | 'EnCoursAnalyse'
  | 'AttentePiecesInstruction'
  | 'Cloture'
  | 'Accorde'
  | 'Annule'
  | 'Refuse'
  | 'Transmis'
  | 'AttentePiecesReglement'
>

export const StatutLibelle: Record<Statut, string> = {
  EnCoursAnalyse: "En cours d'analyse",
  AttentePiecesInstruction: 'Attente pièces instruction',
  RelanceAvantCloture: 'Relance avant clôture',
  Cloture: 'Clôture',
  Accorde: 'Accordé',
  Annule: 'Annulé',
  Refuse: 'Refusé',
  Rupture: 'Rupture',
  Transmis: 'Transmis',
  AttentePiecesReglement: 'Attente pièces règlement',
  TransfereAOpcoMobilite: 'Transféré à Opco Mobilité',
  TransfereAOpco2I: 'Transféré à Opco2I',
  TransfereAOpcommerce: 'Transféré à Opcommerce',
  TransfereAOpcoAtlas: 'Transféré à Opco Atlas',
}

export const StatutBadgeType: Record<Statut, BadgeType> = {
  EnCoursAnalyse: 'pending',
  AttentePiecesInstruction: 'pending',
  RelanceAvantCloture: 'pending',
  Cloture: 'success',
  Accorde: 'success',
  Annule: 'error',
  Refuse: 'error',
  Rupture: 'error',
  Transmis: 'info',
  AttentePiecesReglement: 'pending',
  TransfereAOpcoMobilite: 'info',
  TransfereAOpco2I: 'info',
  TransfereAOpcommerce: 'info',
  TransfereAOpcoAtlas: 'info',
} as const

export const StatutOutilFpeLibelle: Record<StatutOutilFpe, string> = {
  EnCoursAnalyse: "En cours d'analyse",
  AttentePiecesInstruction: 'Attente pièces instruction',
  Cloture: 'Clôture',
  Accorde: 'Accordé',
  Annule: 'Annulé',
  Refuse: 'Refusé',
  Transmis: 'Transmis',
  AttentePiecesReglement: 'Attente pièces règlement',
}

export const StatutOutilFpeBadgeType: Record<StatutOutilFpe, BadgeType> = {
  EnCoursAnalyse: 'pending',
  AttentePiecesInstruction: 'pending',
  Cloture: 'success',
  Accorde: 'success',
  Annule: 'error',
  Refuse: 'error',
  Transmis: 'info',
  AttentePiecesReglement: 'pending',
} as const
